import { render, staticRenderFns } from "./Tef.vue?vue&type=template&id=292ca294"
import script from "./Tef.vue?vue&type=script&lang=js"
export * from "./Tef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports